import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { NgxsModule } from '@ngxs/store';


import { SharedModule } from '@shared/shared.module';

import { SpinnerModule } from '@bayclubs/spinner';
import { PlayersState } from './+store/players.state';
import { ChangePlayerPanelComponent } from './components/change-player-panel/change-player-panel.component';
import { PlayerInfoComponent } from './components/player-info/player-info.component';
import { PlayerListItemComponent } from './components/player-list-item/player-list-item.component';
import { ChangePlayerModalComponent } from './containers/change-player-modal/change-player-modal.component';
import { PlayerAddComponent } from './containers/player-add/player-add.component';
import { PlayerListComponent } from './containers/player-list/player-list.component';
import { PlayerSearchComponent } from './containers/player-search/player-search.component';

@NgModule({
    declarations: [
        ChangePlayerModalComponent,
        ChangePlayerPanelComponent,
        PlayerInfoComponent,
        PlayerListItemComponent,
        PlayerListComponent,
        PlayerSearchComponent,
        PlayerAddComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        NgxsModule.forFeature([PlayersState]),
        NgxsFormPluginModule,
        TranslateModule,
        SharedModule,
        SpinnerModule
    ]
})
export class PlayersModule { }

export * from './models/change-player-input.model';
export * from './services/change-player-launcher.service';

